import styled from "styled-components";

export const ColorPickerContainer = styled.div``;

// Antes isto importava Themes/light estaticamente, então o texto ficava com as
// cores do tema claro mesmo no escuro (label #636466 sobre fundo escuro = ilegível).
// O projeto não usa o ThemeProvider do styled-components: o tema vem por prop.
export const HexInputContainer = styled.div`
  color: ${(props) => props.theme.colors.placeholder};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: normal;
  .input-hex-container {
    width: 50%;
  }
  .label {
    color: ${(props) => props.theme.colors.tertiary};
    font-weight: normal;
  }

  /* O desenho da pílula vem do ColorDisplay. Só que o Input tem campo próprio
     — fundo branco, 6rem de altura, cantos de 10rem — e dentro da pílula isso
     vira um segundo campo. Aqui ele passa a se comportar como o .color-code:
     apenas o texto, ainda editável. A borda fica como está, para o
     border-bottom de foco continuar servindo de indicação. */
  .color-display {
    align-self: flex-start;
    /* background2 é a mesma cor do fundo do modal nos dois temas, então lá a
       pílula sumia. Aqui ela usa a cor de campo do modal (a mesma do dropzone
       da foto), mantendo o contraste que a pílula tem nas configurações. */
    background-color: ${(props) => props.theme.colors.white};

    /* Só a limpeza do chrome nativo do <input>: cor, caixa alta e largura mínima
       já vêm do .color-code do ColorDisplay. */
    input.color-code {
      width: 9rem;
      border: none;
      background: transparent;
      padding: 0;

      &:focus {
        outline: none;
      }

      &::placeholder {
        color: ${(props) => props.theme.colors.placeholder};
      }
    }
  }
`;
